import Modal from 'react-bootstrap/Modal';
import { ButtonPrimary } from '../../../common/components';

type ConsentRequiredProps = {
  onHide: Function;
  show: boolean;
  title: string;
  messagevalues: Messages.IMessagesValues;
};

const defaultProps = {
  onHide: undefined,
  show: false,
  title: 'Smart meter consent required',
  messagevalues: {},
};

export const SmartConsentRequiredModal = (props: ConsentRequiredProps) => {
  return (
    <>
      <Modal.Header className='pt-0'>
        <Modal.Title className='m-0'>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Account <span className='primary'>{props.messagevalues.accountReference}</span> has 1 or more MPAN's that
          require consent to be given to enable us to deliver the Smart meter HH data.
        </p>
        <p>
          You can update the consent status{' '}
          <a className='primary' href='/home/energy-usage/smartmeterconsent'>
            here
          </a>
        </p>
      </Modal.Body>
      <Modal.Footer className='p-0'>
        <ButtonPrimary onClick={() => props.onHide()} className={'mr-0'} title='Ok' route='#' />
      </Modal.Footer>
    </>
  );
};

SmartConsentRequiredModal.defaultProps = defaultProps;
